
import UserLayout from "layout/CustomerUser/UserLayout";
import { renderRoutes } from "./generate-routes";
import { Dashboard } from "features/dashboard";
import ProductDetail from "../features/product/pages/productDetail/ProductDetail";
import {CategoryList, ProductList,} from "../features/product";
import AdInsertStepOne from "../features/adInsert/pages/adInsertStepOne/AdInsertStepOne";
import AdInsertStepTwo from "../features/adInsert/pages/adInsertStepTwo/AdInsertStepTwo";
import {AdInsertStepThree} from "../features/adInsert/pages";
import Profile from "../features/userProfile/pages/profile/Profile";
import {Cartable, SentBorrowRequestList} from "../features/cartable";
import { Login } from "layout";
import { LoginPage } from "features/userManagement/pages";
import  Location from "shared/pages/location/Location";
import {NotificationList} from "../features/notification";
import {BookmarkList} from "../features/bookmark";
import UserProductList from "../features/product/pages/userProductList/UserProductList";
import BorrowRequestList from "../features/cartable/pages/borrowRequest/BorrowRequestList";
import TermsOfService from "../shared/pages/termsAndConditions/TermsOfService";
import Conditions from "../shared/pages/termsAndConditions/Conditions";
import SentRequestList from "../features/cartable/components/sentRequests/SentRequestList";
import SubCategoryList from "../features/product/pages/subCategoryList/SubCategoryList";
import MyProductDetail from "features/product/pages/productDetail/MyProductDetail";
import AdEditStepOne from "../features/adInsert/pages/adInsertStepOne/AdEditStepOne";
import AdEditStepThree from "../features/adInsert/pages/adInsertStepThree/AdEditStepThree";
import AdEditStepTwo from "../features/adInsert/pages/adInsertStepTwo/AdEdittStepTwo";
import AdminPanel from "../features/adminPanel/pages/AdminPanel";

export const routes = [
  {
    layout: UserLayout,
    routes: [
      {
        name: "dashboard",
        title: "داشبورد",
        component: Dashboard,
        path: "/",
        isPublic: false,
      },
      {
        name: "ProductDetail",
        title: "محصول",
        component: ProductDetail,
        path: "/product-detail/:id",
      },
      {
        name: "MyProductDetail",
        title: "اگهی های من",
        component: MyProductDetail,
        path: "/myProduct-detail/:id",
      },
      {
        name: "ProductDetail",
        title: "دست بندی",
        component: CategoryList,
        path: "/category-list",
      },
      {
        name: "ProductList",
        title: "محصولات",
        component: ProductList,
        path: "/product-list/:categoryId?/:subCategoryId?",
      },
      {
        name: "SubCategoryList",
        title: "محصولات",
        component: SubCategoryList,
        path: "/sub-category-list/:categoryId?",
      },
      {
        name: "AdInsertStepOne",
        title: "درج آگهی",
        component: AdInsertStepOne,
        path: "/ad-insert-step-one",
      },
      {
        name: "AdInsertStepTwo",
        title: "درج آگهی",
        component: AdInsertStepTwo,
        path: "/ad-insert-step-two",
      },
      {
        name: "AdInsertStepTwo",
        title: "درج آگهی",
        component: AdInsertStepThree,
        path: "/ad-insert-step-three",
      },
      {
        name: "AdEditStepOne",
        title: "ویرایش آگهی",
        component: AdEditStepOne,
        path: "/ad-edit-step-one/:id",
      },
      {
        name: "AdEditStepTwo",
        title: "ویرایش آگهی",
        component: AdEditStepTwo,
        path: "/ad-edit-step-two/:id",
      },
      {
        name: "AdEditStepThree",
        title: "ویرایش آگهی",
        component: AdEditStepThree,
        path: "/ad-edit-step-three/:id",
      },
      {
        name: "Profile",
        title: "نمایه کاربری",
        component: Profile,
        path: "/user-profile",
      },
      {
        name: "Cartable",
        title: "کارپوشه",
        component: Cartable,
        path: "/cartable",
      },
      {
        name: "Location",
        title: "مکان",
        component: Location,
        path: "/location",
      },
      {
        name: "Notification",
        title: "اعلانات",
        component: NotificationList,
        path: "/notification",
      },
      {
        name: "BookmarkList",
        title: "آگهی های موردعلاقه",
        component: BookmarkList,
        path: "/bookmark-list",
      },
      {
        name: "UserProductList",
        title: "آگهی های من",
        component: UserProductList,
        path: "/user-products",
      },
      {
        name: "BorrowRequestList",
        title: "درخواست های دریافت شده",
        component: BorrowRequestList,
        path: "/BorrowRequests/:requestId?",
      }
      ,{
        name: "TermsOfService",
        title: "حریم خصوصی",
        component: TermsOfService,
        path: "/terms",
      },{
        name: "Conditions",
        title: "شرایط",
        component: Conditions,
        path: "/conditions",
      }
      ,{
        name: "AdminPanel",
        title: "پنل ادمین",
        component: AdminPanel,
        path: "/admin-panel",
      },

    ],
  },
  {
    layout: Login,
    routes: [
      {
        name: "signIn",
        title: "ورود به سیستم",
        component: LoginPage,
        path: "/login",
        isPublic: true,
      },

    ],
  },

];

export const Routes = renderRoutes(routes);
